import type { UseFormReturn } from 'react-hook-form'
import type { IntakeFormData } from '@orientamos/shared'
import { PartyForm } from '../PartyForm'

interface Step3Props {
  form: UseFormReturn<IntakeFormData>
}

export function Step3Tenant({ form }: Step3Props) {
  return (
    <PartyForm
      form={form}
      basePath="tenant"
      title="Datos del Arrendatario"
      description="Ingresa la informacion completa del arrendatario (inquilino)"
      showBanking={false}
      personTypeToggle={true}
    />
  )
}
